/**
 * Rating value the backend uses for "no rating given" (Geen beoordeling).
 * It fills the grey rest of the donut chart and gets no count badge.
 */
export const UNRATED_GROUP_MEETING_RATING = 5;

export const GROUP_MEETING_RATING_VALUES = [1, 2, 3, 4, 5] as const;

export type GroupMeetingRatingValue =
  (typeof GROUP_MEETING_RATING_VALUES)[number];

/**
 * Chart segment and badge dot colors per rating value. Traffic-light palette,
 * matching RATING_LEVELS in meetings/shared/constants (GitHub #1388).
 * Labels live in i18n: `pages.groupMeeting.ratingLabels`.
 */
export const GROUP_MEETING_RATING_COLORS: Record<number, string> = {
  1: "#4294EE",
  2: "#60B67F",
  3: "#FCB653",
  4: "#EC6244",
  5: "#F8F8FA",
};

/** Darker variants for text (remark author names) so they stay readable. */
export const GROUP_MEETING_RATING_TEXT_COLORS: Record<number, string> = {
  1: "#306FB5",
  2: "#336646",
  3: "#A06E1B",
  4: "#B53317",
  5: "#848EAD",
};
